import RecentSearches from '../../components/fullscreenSearch/RecentSearches';
import { Section } from 'foundations-components/transitional/components/Section';
import SearchSuggestions from '../../components/fullscreenSearch/SearchSuggestions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmptySearchSection = () => {
  return /*#__PURE__*/_jsxs(Section, {
    "data-test-id": "global-search-empty-state",
    children: [/*#__PURE__*/_jsx(RecentSearches, {}), /*#__PURE__*/_jsx(SearchSuggestions, {})]
  });
};
export default EmptySearchSection;